// extracted by mini-css-extract-plugin
module.exports = {"layout":"_3Qz0Zua"};